import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CreateDocumentRevisionsBatchRequest extends GenericRequest {

    // DocumentRevisionBatchSave {
    //     document_ids: number[]
    //     start_date: string
    //     end_date: string
    //     files: FileSaveWithUUID[]
    // }
    //
    // FileSaveWithUUID{
    //     url: string
    //     contents: string
    //     file_type_id: number
    //     size: number
    //     mime_type: string
    //     uuid: string
    // }

    documentRevisionBatchSave;

    constructor(documentRevisionBatchSave) {
        super(METHOD_PUT, ApiEndpoints.DOCUMENT_REVISIONS_BATCH);
        this.documentRevisionBatchSave = documentRevisionBatchSave;
    }

    overrideRequest() {
        return this.documentRevisionBatchSave;
    }

}



// WEBPACK FOOTER //
// ./src/app/documents/ws/CreateDocumentRevisionBatchRequest.js